import { getLocation } from '@office-start/url-parser-utility';
import { oneDriveConsumerUrlRegex } from './constants';
export function getFileAttributionUrl(fileUrl, isLocalFile) {
    var _a;
    if (isLocalFile === void 0) { isLocalFile = false; }
    var pathSeparator = isLocalFile ? '\\' : '/';
    var lastPathSeparatorIndex = fileUrl
        ? fileUrl.lastIndexOf(pathSeparator)
        : -1;
    var attributionUrl = lastPathSeparatorIndex === -1
        ? fileUrl
        : fileUrl.substring(0, lastPathSeparatorIndex + 1);
    // Must add id=root query string parameter for files at the root of the OneDrive Consumer drive.
    if (attributionUrl.match(oneDriveConsumerUrlRegex)) {
        var attributionPath = (_a = getLocation(attributionUrl)) === null || _a === void 0 ? void 0 : _a.path;
        if (!attributionPath) {
            return attributionUrl;
        }
        if (attributionPath.lastIndexOf('/', attributionPath.length - 2) <= 0) {
            return "".concat(attributionUrl, "?id=root");
        }
    }
    return attributionUrl;
}
//# sourceMappingURL=getFileAttributionUrl.js.map